import { useCallback, useRef } from 'react';

/** Slightly longer than the 641ms reflex double-click observed in replay. */
export const TOGGLE_GUARD_MS = 800;

/** Leading-edge throttle for layer toggles. */
const useToggleGuard = (
  onToggle: () => void,
  guardMs: number = TOGGLE_GUARD_MS,
): (() => void) => {
  const lastAcceptedAt = useRef(0);

  return useCallback(() => {
    const now = Date.now();
    if (now - lastAcceptedAt.current < guardMs) return;

    lastAcceptedAt.current = now;
    onToggle();
  }, [onToggle, guardMs]);
};

export default useToggleGuard;
